<template>
  <el-dialog title="Reopen" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="138px">
      <el-form-item label="Audit Remark" v-if="engagementDetail.reopenStatus == 2 && engagementDetail.reopenAuditRemark">
        <span>{{ engagementDetail.reopenAuditRemark }}</span>
      </el-form-item>
      <el-form-item label="Reopen Reason" prop="reopenReason">
        <el-input
          v-model="dataForm.reopenReason"
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 4 }"
          resize="none"
          placeholder="Reopen Reason"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    engagementId: {
      type: [String, null],
      require: true,
    },
    engagementDetail: {
      type: Object,
      default: function () {
        return {
          reopenStatus: null,
          reopenAuditRemark: null,
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        reopenReason: "",
      },
      dataRule: {
        reopenReason: [{ required: true, message: "please enter", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    async init() {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(`/admin/engagementManage/${this.engagementId}/reopenRequest`, this.dataForm)
            .then(res => {
              this.$emit("reOpenFeedback");
              this.visible = false;
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
